var _path, _path2, _circle, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgAddGuests = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  fill: "none",
  viewBox: "0 0 48 48"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#333",
  strokeMiterlimit: 10,
  strokeWidth: 1.25,
  d: "M18.625 19a7 7 0 1 0 0-14 7 7 0 0 0 0 14Z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#333",
  fillRule: "evenodd",
  d: "M25.96 21.682a10.35 10.35 0 0 0-5.574-2.905 7 7 0 0 0 1.897-.808 11.6 11.6 0 0 1 4.563 2.832 11.7 11.7 0 0 1 1.826 2.384 9 9 0 0 0-1.247.35 10.4 10.4 0 0 0-1.465-1.853m-4.87 12.693H9.401c-.305 0-.597-.121-.813-.34a1.17 1.17 0 0 1-.339-.822v-4.238a10.48 10.48 0 0 1 3.071-7.325 10.35 10.35 0 0 1 5.542-2.873 7 7 0 0 1-1.897-.808 11.6 11.6 0 0 0-4.527 2.796A11.73 11.73 0 0 0 7 28.967v4.245c0 .64.252 1.252.702 1.705s1.061.708 1.7.708H21.33a10 10 0 0 1-.242-1.25",
  clipRule: "evenodd"
})), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 31,
  cy: 33,
  r: 10.375,
  stroke: "#333",
  strokeWidth: 1.25
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  stroke: "#333",
  strokeLinecap: "round",
  strokeWidth: 1.25,
  d: "M31.005 27.125v11.75M36.875 33.005h-11.75"
})));
export { SvgAddGuests as ReactComponent };